import * as React from 'react';
import { Shimmer, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { Fabric } from '@fluentui/react/lib/Fabric';
import { mergeStyles } from '@fluentui/react/lib/Styling';

const wrapperClass = mergeStyles({
  padding: 2,
  selectors: {
    '& > .ms-Shimmer-container': {
      margin: '10px 0',
    },
  },
});
const shimmerTableRow = [
  { type: ShimmerElementType.gap, width: '2%' },
  { type: ShimmerElementType.line, height: 16, width: '30%' },
  { type: ShimmerElementType.gap, width: '2%' },
  { type: ShimmerElementType.line, height: 16, width: '30%' },
  { type: ShimmerElementType.gap, width: '2%' },
  { type: ShimmerElementType.line, height: 16, width: '30%' },
];

export const CustomShimmer: React.FunctionComponent = () => {
  return (
    <Fabric className={wrapperClass}>
      <Shimmer height={'20'} width="100%"/>
      <p style={{ height: 20 }}>&nbsp;</p>
      <Shimmer height={'20'} width="20%"/>
      <p style={{ height: 20 }}>&nbsp;</p>
      <Shimmer shimmerElements={shimmerTableRow}/>
      <Shimmer shimmerElements={shimmerTableRow}/>
      <Shimmer shimmerElements={shimmerTableRow}/>
      <p style={{ height: 20 }}>&nbsp;</p>
      <Shimmer height={'20'} width="20%"/>
    </Fabric>
  );
};
